// IMPORT REACT
import React from 'react';

// IMPORT STYLES
import { SC_Container } from '../styles';


const YAContainer = (props) => {    
    return (
    	<SC_Container {...props}>
            {props.children}
        </SC_Container>
    )
    
}
export default YAContainer;